import { BadStateError } from '@skand/utils';
import ss from 'streamsaver';

export interface BinarySaver {
  save(binary: Blob | Response, filename: string): Promise<void>;
}

export class BlobSaver implements BinarySaver {
  async save(binary: Blob | Response, filename: string) {
    const blob = binary instanceof Blob ? binary : await binary.blob();
    const dom = document.createElement('a');
    const url = URL.createObjectURL(blob);
    dom.href = url;
    dom.download = filename;
    dom.click();
    dom.remove();
    URL.revokeObjectURL(url);
  }
}

export class StreamSaver implements BinarySaver {
  async save(binary: Blob | Response, filename: string) {
    const fileStream = ss.createWriteStream(filename);
    if (binary instanceof Blob) {
      await binary.stream().pipeTo(fileStream);
    } else {
      if (binary.body === null) throw new BadStateError('response has no body to save');
      await binary.body!.pipeTo(fileStream);
    }
  }
}
